import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2f62e6b7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "success__steps"
};
const _hoisted_2 = {
  class: "success__steps-top"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "success__steps-lines"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "line-left"
})], -1));
const _hoisted_4 = {
  class: "success__steps-number"
};
const _hoisted_5 = {
  class: "steps-number"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "success__steps-lines"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "line-right"
})], -1));
const _hoisted_7 = {
  class: "success__steps-text"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.methods === 'Доставка' ? $data.stepsDelivery : $data.stepsPickup, (item, id) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["success__steps-item", {
        'steps--check': id <= $props.steps
      }]),
      key: id
    }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(id + 1), 1)]), _hoisted_6]), _createElementVNode("p", _hoisted_7, [_createTextVNode(_toDisplayString(item.split(" ")[0]), 1), _hoisted_8, _createTextVNode(_toDisplayString(item.split(" ").slice(1).join(" ")), 1)])], 2);
  }), 128))]);
}